const actionTypes = {
  // Fetch vessels with pagination
  REQUEST_VESSELS: 'REQUEST_VESSELS',
  SET_REQUESTING_VESSELS: 'SET_REQUESTING_VESSELS',
  VESSELS_REQUEST_SUCCESSFUL: 'VESSELS_REQUEST_SUCCESSFUL',
  VESSELS_REQUEST_UNSUCCESSFUL: 'VESSELS_REQUEST_UNSUCCESSFUL',

  // Fetch single vessel
  REQUEST_VESSEL: 'REQUEST_VESSEL',
  SET_REQUESTING_VESSEL: 'SET_REQUESTING_VESSEL',
  VESSEL_REQUEST_SUCCESSFUL: 'VESSEL_REQUEST_SUCCESSFUL',
  VESSEL_REQUEST_UNSUCCESSFUL: 'VESSEL_REQUEST_UNSUCCESSFUL',

  // Pagination and search
  SET_VESSEL_PAGE: 'SET_VESSEL_PAGE',
  SET_VESSEL_PAGE_SIZE: 'SET_VESSEL_PAGE_SIZE',
  SET_VESSEL_SEARCH_QUERY: 'SET_VESSEL_SEARCH_QUERY',

  // Unified save vessel details (create/update/clone)
  SAVE_VESSEL_DETAILS: 'SAVE_VESSEL_DETAILS',
  SET_REQUESTING_SAVE_VESSEL_DETAILS: 'SET_REQUESTING_SAVE_VESSEL_DETAILS',
  SET_SAVE_VESSEL_DETAILS_ERROR: 'SET_SAVE_VESSEL_DETAILS_ERROR',

  // Export vessel
  EXPORT_VESSEL: 'EXPORT_VESSEL',
}

export default actionTypes
